import React from "react";

// CSS
import "../../../css/errors-success/errors.css";

class ErrorWrap extends React.PureComponent {
	render() {
		const errors = this.props.children;

		return (
			<div
				className={
					`error-wrap` +
					(this.props.animate ? ` msg-animate` : ``) +
					(!!this.props.classes ? ` ${this.props.classes}` : ``)
				}
			>
				{typeof errors === "object"
					? Object.keys(errors).map(function(key) {
							return <div key={key}>{errors[key]}</div>;
					  })
					: errors}
			</div>
		);
	}
}

export default ErrorWrap;



// WEBPACK FOOTER //
// ./src/components/utils/error-success/ErrorWrap.js